import { TRM_DOCUMENTS } from '../../functions/src/common/trmWorkflow';

export const TRM_BRIEF_TABS = [
    { id: 'overview', label: 'Overview', documentKey: 'masterBrief' },
    { id: 'itinerary', label: 'Itinerary', documentKey: 'legMatrix' },
    { id: 'accommodation', label: 'Accommodation', documentKey: 'accommodationReport' },
    { id: 'medical', label: 'Medical', documentKey: 'medicalPlan' },
    { id: 'departure', label: 'Departure', documentKey: 'departureCard' },
    { id: 'digital_security', label: 'Digital Security', documentKey: 'counterSurveillance' },
] as const;

export type TrmBriefTab = typeof TRM_BRIEF_TABS[number]['id'];
export type TrmWorkspaceTab = TrmBriefTab | 'alerts' | 'documents';

export const TRM_WORKSPACE_TABS = [...TRM_BRIEF_TABS,
    { id: 'alerts', label: 'Alerts' }, { id: 'documents', label: 'Documents' }] as const;

export function trmWorkspaceDocument(tab: TrmWorkspaceTab, documents: Record<string, string> | undefined,
    publishedAt?: string, preview = false) {
    const section = TRM_BRIEF_TABS.find(item => item.id === tab);
    const document = TRM_DOCUMENTS.find(item => item.key === section?.documentKey);
    return document ? { ...document, content: publishedAt || preview ? documents?.[document.key] || '' : '' } : null;
}
